import React from 'react';

const ReconciliationReports = () => {
	return <></>;
};

export default ReconciliationReports;
